import React from "react";
// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../widgets/tables/Table';
import Loading from "../components/Loading";
import MyModalProdotti from "../widgets/MyModalProdotti";
import getFornitori from "../services/getFornitori";
import getProdotti from "../services/getProdotti";
import deleteProdotto from "../services/deleteProdotto";
import checkToken from "../services/checkToken";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
export default class Prodotti extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      isLoading: true,
      modalEdit: {
        show: false,
      },
      modalAdd: {
        show: false,
      },
  };
  }

  close = () => {
    let modalAdd = this.state.modalAdd;
    modalAdd.show = false;

    let modalEdit = this.state.modalEdit;
    modalEdit.show = false;
    this.setState({ modalEdit, modalAdd, selectedProdotto: null });
  }

  async reload() {
    this.setState({ isLoading: true });

    cookies.remove('prodotto', { path: '/' });

    this.prodotti = await getProdotti(username, token);
    this.fornitori = await getFornitori(username, token);

    // Aggiorna i prodotti con i fornitori
    this.prodotti = this.prodotti.map((prodotto) => {
      let fornitori = JSON.parse(prodotto.id_fornitore)
      let fornitoriString = '';
      fornitori.forEach((fornitore, index) => {
        let f = this.fornitori.find((f) => f.id === fornitore)
        fornitoriString += f.ragione_sociale + (index < fornitori.length - 1 ? ', ' : '')
      })

      return {
        ...prodotto,
        ragione_sociale: fornitoriString,
      }
    });

    if(this.props.location.state && this.prodotti && this.prodotti.length > 0){
      let x = {
        show: true,
      }

    this.setState({ modalEdit: x, selectedProdotto: this.prodotti.find((prodotto) => prodotto.id === this.props.location.state.id).id });
    this.props.location.state = null;
    }

    const check = await checkToken(username, token, true);
    const userType = parseInt(check.utente.tipo);

    this.setState({ isLoading: false, isUserType: (userType === 0 || userType === 4) });
  }

  async componentDidMount() {

    username = cookies.get('username', { path: '/' });
    token = cookies.get('token', { path: '/' });   
     
    await this.reload();
  }

  async delete(row) {
    if (window.confirm("Sei sicuro di voler eliminare questo prodotto?") === false) return;

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    await deleteProdotto(username, token, row);
    this.reload();
  }


  render() {
    if (this.state.isLoading)
      return <Loading />;

    const cookies = new Cookies();
    var headCells = [
      { id: 'nome', numeric: false, disablePadding: false, label: 'Nome' },
      { id: 'codice', numeric: false, disablePadding: false, label: 'Codice' },
      { id: 'prezzo', numeric: false, disablePadding: false, label: 'Prezzo' },
      { id: 'costo', numeric: false, disablePadding: false, label: 'Costo' },
      { id: 'ragione_sociale', numeric: false, disablePadding: false, label: 'Fornitore' },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];


    this.searchCols = ['nome', 'codice', 'ragione_sociale'];

    return (
      <div id={Math.random()}>

        {
          this.state.isUserType && <PageTitle title="Prodotti" button={"CREA NUOVO"} onClick={() => {
            let x = {
              show: true,
            };
            this.setState({ modalAdd: x });
          }} />
        }

        {
          !this.state.isUserType && <PageTitle title="Prodotti" />
        }

        {
          this.state.isUserType && <Table headCells={headCells} searchCols={this.searchCols} rows={this.prodotti}
            onEventClick={(row) => {
              cookies.set('prodotto', row, { path: '/' });
              this.setState({ selectedProdotto: row, modalEdit: { show: true } })
            }}

            onDelete={this.state.isUserType ? this.delete.bind(this) : null}
          />
        }

        {
          !this.state.isUserType && <Table headCells={headCells} searchCols={this.searchCols} rows={this.prodotti}
            onEventClick={(row) => {
              cookies.set('prodotto', row, { path: '/' });
              this.setState({ modalEdit: { show: true }, selectedProdotto: row })
            }}
          />
        }

        {
          this.state.modalAdd.show && (<MyModalProdotti modal={this.state.modalAdd} title={"Nuovo Prodotto"} fornitori={this.fornitori} onClose={this.close} onReload={() => this.reload()} isUserType={this.state.isUserType} />)
        }

        {
          this.state.modalEdit.show && (<MyModalProdotti prodotto={this.state.selectedProdotto} modal={this.state.modalEdit} title={this.state.isUserType ? "Modifica Prodotto" : "Informazione Prodotto"} fornitori={this.fornitori} onClose={this.close} onReload={() => this.reload()} isUserType={this.state.isUserType} />)
        }

      </div>
    );
  }
}
